import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/bus-outline-blue-default.svg'
import _imports_1 from '@/assets/img/icon/currency-dollar-outline-blue.svg'


const _hoisted_1 = { class: "helpdesk-detail" }
const _hoisted_2 = { class: "flex gap-6 mb-4" }
const _hoisted_3 = { class: "w-full md:w-1/3 border-grey-3 p-20px rounded-lg flex flex-col" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "text-grey font-normal text-base" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Nomor Lambung: ")
const _hoisted_7 = { class: "text-grey font-bold text-base" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "text-30px font-extrabold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "40",
    height: "40"
  })
], -1)
const _hoisted_11 = { class: "mt-auto" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Jadwal:", -1)
const _hoisted_13 = { class: "flex items-center gap-3" }
const _hoisted_14 = { class: "text-base font-bold text-primary" }
const _hoisted_15 = { class: "w-full md:w-1/3 border-grey-3 p-20px rounded-lg flex flex-col" }
const _hoisted_16 = { class: "flex justify-between" }
const _hoisted_17 = { class: "text-grey font-normal text-base" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Kode Transaksi: ")
const _hoisted_19 = { class: "text-green font-bold text-base" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "text-30px font-extrabold" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "40",
    height: "40"
  })
], -1)
const _hoisted_23 = { class: "flex items-center gap-3 mt-auto" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Jumlah Penumpang:", -1)
const _hoisted_25 = { class: "text-base font-bold text-primary" }
const _hoisted_26 = { class: "w-full md:w-1/3" }
const _hoisted_27 = { class: "mb-2 border-grey-3 px-20px py-10px rounded-lg" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-base text-grey font-normal" }, "Kondektur", -1)
const _hoisted_29 = { class: "text-xl font-extrabold" }
const _hoisted_30 = { class: "border-grey-3 px-20px py-10px rounded-lg" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text-base text-grey font-normal" }, "Sopir", -1)
const _hoisted_32 = { class: "text-xl font-extrabold" }
const _hoisted_33 = {
  class: "cntnr-ctn",
  style: {"min-height":"60vh"}
}
const _hoisted_34 = { class: "mt-30" }
const _hoisted_35 = { class: "border-top-grey-3 p-3" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "PP ditutup pada tanggal:", -1)
const _hoisted_38 = { class: "text-primary font-bold" }
const _hoisted_39 = { class: "text-right" }
const _hoisted_40 = { class: "flex items-center justify-end gap-3" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Tutup PP")
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-xs italic mt-3" }, "* Pastikan seluruh RIT telah ditutup dan semua data pendapatan serta pengeluaran sudah benar.", -1)

import { onMounted, ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import Card from 'primevue/card'
import apiUseCase from '@/usecase/apiUseCase'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import HjpTabView from '@/views/components/tab/HjpTabView.vue'
import moment from 'moment'
import Button from 'primevue/button'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import TicketSoldList from './components/TicketSoldList.vue'
import ControllerList from './components/ControllerList.vue'
import CloseRitDialog from './components/CloseRitDialog.vue'
import ClosePpDialog from './components/ClosePpDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const transactionPpEndpoint = '/transaction/v2/transactionPps'

const store = useStore()
const route = useRoute()
const dataId = ref(route.params.id)
const routeName = (route.name as string).replace('-detail', '')
const showCloseRitDialog = ref(false)
const activeTab = ref(0)
const selectedRitId = ref(null) as any
const isCanClosePp = ref(false)
const showClosePpDialog = ref(false)
const tabsChange = (val: number) => {
  activeTab.value = val
}
const dataSource = ref()

const attrModalConfirmation = reactive({
  show: false,
  title: 'Turunkan Kontroler?',
  subTitle: 'Pastikan kontroler yang akan Anda turunkan sudah benar-benar keluar dari bus!',
  btnSubmitTitle: 'Turunkan Kontroler',
  imgContent: require('@/assets/img/modal-confirmation/dropoff-controller.svg')
})

const setBreadcrumbs = () => {
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Approve Setoran',
      routeName
    },
    {
      title: dataSource.value?.TrxId,
      routeName: `${route.name as string}`
    }
  ])
}

const checkActiveRitAvailable = () => {
  const cekRit = dataSource.value.Rits?.filter((data: any) => data.MsStatusId !== 8)
  console.log('cekRit', cekRit)
  isCanClosePp.value = cekRit.length === 0 && dataSource.value.MsStatusId < 3
}

const getDataDetail = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpEndpoint}/${dataId.value}`).then((response) => {
    const {
      error,
      result
    } = response
    if (!error) {
      dataSource.value = result
      checkActiveRitAvailable()
      // setBreadcrumbs()
    }
  })
  store.dispatch('hideLoading')
}

const fetchHeaderDetailData = () => {
  console.log('reloadHeaderAct')
  getDataDetail()
}

const closeRitDialogAct = async () => {
  store.dispatch('showLoading')
  store.dispatch('hideLoading')
}

const showCloseRitDialogAct = (id: any) => {
  selectedRitId.value = id
  showCloseRitDialog.value = true
  console.log('id', id)
}

const hideCloseRitDialogAct = (id: any) => {
  showCloseRitDialog.value = false
  selectedRitId.value = null
}

const openPpSummaryDialog = () => {
  showClosePpDialog.value = true
}

const hidePpSummaryDialog = () => {
  showClosePpDialog.value = false
}

onMounted(() => {
  getDataDetail()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "card-no-shadow" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(dataSource.value?.VehicleHullNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(dataSource.value?.VehicleRegNumber), 1)
                ])
              ]),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(moment)(dataSource.value?.RosterDate).format('DD MMMM YYYY - HH:mm')), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(dataSource.value?.MsStatusId === 45 ? 'chip-red-solid' : 'chip-green-solid')
                }, _toDisplayString(dataSource.value?.MsStatusName), 3)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, _toDisplayString(dataSource.value?.TrxId), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(currencyNumberFormat)(dataSource.value?.TotalTicketAmount)), 1)
                ])
              ]),
              _hoisted_22
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(dataSource.value?.TotalTicket), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, _toDisplayString(dataSource.value?.CondecturName), 1)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, _toDisplayString(dataSource.value?.DriverName), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(HjpTabView, {
            tabHeader: [
            { title: 'Daftar Tiket Terjual', value: 0 },
            { title: 'Daftar Kontroler yang Bertugas', value: 1 }
          ],
            onTabsChange: tabsChange
          }),
          _createElementVNode("div", _hoisted_34, [
            (activeTab.value === 0)
              ? (_openBlock(), _createBlock(TicketSoldList, {
                  key: 0,
                  ritList: dataSource.value?.Rits,
                  onShowCloseRitDialog: showCloseRitDialogAct,
                  onReloadHeader: fetchHeaderDetailData
                }, null, 8, ["ritList"]))
              : (activeTab.value === 1)
                ? (_openBlock(), _createBlock(ControllerList, {
                    key: 1,
                    ritList: dataSource.value?.Rits,
                    onShowCloseRitDialog: showCloseRitDialogAct,
                    onReloadHeader: fetchHeaderDetailData
                  }, null, 8, ["ritList"]))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", {
            class: _normalizeClass(["grid", dataSource.value?.MsStatusId > 2 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1'])
          }, [
            (dataSource.value?.MsStatusId > 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(moment)(dataSource.value?.ClosedDate).format('DD MMMM YYYY - HH:mm')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_unref(Button), {
                  class: "btn-back",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'helpdesk' })))
                }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  class: _normalizeClass(isCanClosePp.value ? 'btn-primary text-white mr-3 px-10 py-1' : 'btn-disabled'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isCanClosePp.value ? openPpSummaryDialog() : ''))
                }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _hoisted_43
            ])
          ], 2)
        ])
      ]),
      _: 1
    }),
    (showCloseRitDialog.value)
      ? (_openBlock(), _createBlock(CloseRitDialog, {
          key: 0,
          show: showCloseRitDialog.value,
          trayekId: dataSource.value?.TrayekId,
          ritId: _unref(selectedRitId),
          dataHeader: {
        condecturId: dataSource.value.condecturId,
        condectur: dataSource.value.CondecturName,
        driver: dataSource.value.DriverName,
        helper: dataSource.value.HelperName
      },
          onHideDialogCloseRit: hideCloseRitDialogAct,
          onReloadData: fetchHeaderDetailData
        }, null, 8, ["show", "trayekId", "ritId", "dataHeader"]))
      : _createCommentVNode("", true),
    (showClosePpDialog.value)
      ? (_openBlock(), _createBlock(ClosePpDialog, {
          key: 1,
          show: showClosePpDialog.value,
          onHideDialog: hidePpSummaryDialog,
          dataHeader: dataSource.value,
          onReloadHeader: getDataDetail
        }, null, 8, ["show", "dataHeader"]))
      : _createCommentVNode("", true)
  ]))
}
}

})